import { useSuspenseGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { importSettingRecord } from "@/app/Import/GraphQL/updateImportSettingsMutation";
import { RelocationItemInput } from "@/gql/graphql";
import { GridState } from "ag-grid-community";
import {
  defaultColOrder,
  defaultHiddenCols,
  ImportColumnId,
} from "@/app/Import/Utils/defaultColumnOrder";
import { transformFileInputToRowData } from "@/app/Import/Utils/transformFileInputToRowData";

export function useGetTransformFileInputToRowData(
  supplierId: string,
): (rowData: any[][]) => RelocationItemInput[] {
  const { data: importSettingRes } = useSuspenseGqlQuery(importSettingRecord, {
    supplierId,
  });

  const gridState = importSettingRes?.importSetting?.grid_state as
    | GridState
    | undefined;

  const fullOrder = (gridState?.columnOrder?.orderedColIds ??
    defaultColOrder) as ImportColumnId[];

  const hiddenColIds = (gridState?.columnVisibility?.hiddenColIds ??
    defaultHiddenCols) as ImportColumnId[];

  return (rawData): RelocationItemInput[] => {
    return transformFileInputToRowData(rawData, {
      fullOrder,
      hiddenColIds,
      ignoreColumns: importSettingRes.importSetting?.ignore_columns ?? "",
      ignoreHeaderRow: !!importSettingRes?.importSetting?.ignore_header_row,
      ignoreMissingLine: !!importSettingRes?.importSetting?.ignore_missing_line,
    });
  };
}
